export const LOAD_REPORT_BLOOD_PRESSURE_REQUEST = 'LOAD_REPORT_BLOOD_PRESSURE_REQUEST';
export const LOAD_REPORT_BLOOD_PRESSURE_SUCCESS = 'LOAD_REPORT_BLOOD_PRESSURE_SUCCESS';
export const LOAD_REPORT_BLOOD_PRESSURE_FAILURE = 'LOAD_REPORT_BLOOD_PRESSURE_FAILURE';

export const LOAD_MORE_REPORT_BLOOD_PRESSURE_REQUEST = 'LOAD_MORE_REPORT_BLOOD_PRESSURE_REQUEST';
export const LOAD_MORE_REPORT_BLOOD_PRESSURE_SUCCESS = 'LOAD_MORE_REPORT_BLOOD_PRESSURE_SUCCESS';
export const LOAD_MORE_REPORT_BLOOD_PRESSURE_FAILURE = 'LOAD_MORE_REPORT_BLOOD_PRESSURE_FAILURE';
